<!-- 下载按钮 -->
<template>
<div class='footer'>
  <div class="download" @click='handleDownload'>
    <p class="des_f">一键收藏全部（90）</p>
    <!-- <p class="des_s">“才博”点击下载 APP</p> -->
  </div>
  <div @click.stop='handleStarClick' class="star" />
  <Modal
    :isShow='isShow'
    :title='title'
    :content='content'
    :button='button'
    :tag='login'
    @close='handleClose'
  />
</div>
</template>

<script>
import login from '@edu-fe/login'
import Modal from './modal'
import api from '@edu-fe/api'
export default {
components: {
  Modal
},
  data() {
    return {
      isShow: false,
      title: '每日小技巧需要您的登录',
      content: '为什么需要登录？因为需要将课程发放到您的专属账户。',
      button: '了解了，去登录',
      login: true,
    };
  },
  props:{
    changeCollect: Function,
  },
  computed: {},
  watch: {},
  methods: {
    handleClose() {
      this.isShow = false
    },
    handleStarClick() {
      this.$emit('changeCollect')
    },
    async checkLogin () {
      const wpsSid = await login.getWpsSid()
      if(!wpsSid) {
        this.isShow = true
        return ''
      }
      // 下载
      this.isShow = true
      this.login = false
      this.title = '收藏成功'
      this.content = '如何查看？下载“才博”app在已购页面查看。'
      this.button = '去下载'
      
    },
    async handleDownload() {
      const { data } = await api.diversion.add()
      // 判断登录
      this.checkLogin()
    }
  },
  created() {

  },
  mounted() {

  },
}
</script>
<style lang='scss' scoped>
  @charset "UTF-8";

  @import "../../../style/main";
.footer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: rem(0);
  z-index: 999;
  height:rem(173);
  background:linear-gradient(180deg,rgba(255,255,255,0) 0%,rgba(255,255,255,0.63) 42%,rgba(255,255,255,1) 100%);
  .download {
    width:rem(556);
    height:rem(94);
    background:rgba(255,255,255,1);
    box-shadow:rem(0) rem(12) rem(36) rem(0) rgba(51,51,51,0.1);
    border-radius:rem(68);
    border:rem(1) solid rgba(209,209,209,1);
    font-weight:400;
    text-align: center;
    line-height: rem(94);
    .des_f {
      font-size: rem(34);
      color:rgba(51,51,51,1);
      line-height: rem(94);
    }
    .des_s {
      font-size: rem(22);
      color:rgba(153,153,153,1);
      line-height: rem(33);
    }
  }
  .star {
    width: rem(94);
    height: rem(94);
    background: url(../../../assets/icons/diversion_star.png);
    background-size: 100% 100%;
    box-shadow:rem(0) rem(12) rem(36) rem(0) rgba(51,51,51,0.2);
    border-radius:rem(68);
    border: rem(1) solid rgba(240,240,240,1);
    margin-left: rem(34);
    z-index: 9999
  }
}


</style>
